import React from 'react';
import BasicTag from '../BasicTag';
import { RiSearchEyeLine } from 'react-icons/ri';

const ViewTag = () => {
  return <BasicTag color="gold" text="顯示群組" Icon={RiSearchEyeLine} />;
};

export default ViewTag;
